<template>
    <div class="vehicle-specification">
        <div class="row">
            <div class="col-12">
                <h5>Specification &amp; Optional Extras</h5>
            </div>
        </div>

        <!-- Tabs / Accordions -->
        <div class="tabs-accordions">
            <div class="row">
                <div class="col-12">

                    <!-- Tabs -->
                    <div class="tabs">
                        <div class="row mb-0">
                            <div class="col-12">
                                <div class="d-flex flex-row">
                                    <button class="text-uppercase"
                                            :class="{ 'active' : tab === 'optional-extras'}"
                                            @click="tabs('optional-extras')">Selected
                                        optional extras
                                    </button>
                                    <button class="text-uppercase"
                                            :class="{ 'active' : tab === 'standard-specification' }"
                                            @click="tabs('standard-specification')">
                                        Standard specification
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Accordions -->
                    <div class="accordions">
                        <!-- Optional Extras -->
                        <div v-if="tab === 'optional-extras'">
                            <div class="row">
                                <div class="col-12">

                                    <div  v-if="quote" class="accordion" id="optional-extras">

                                        <div

                                            v-for="(options, index) in quote.factoryOptionsGrouped"
                                            :key="`optional-extras-${sanitizeTitle(index)}`">

                                            <!-- Header-->
                                            <div class="card-header"
                                                 :id="`${sanitizeTitle(index)}-header`">
                                                <h2 class="mb-0">
                                                    <button class="btn" type="button"
                                                            data-bs-toggle="collapse"
                                                            :data-bs-target="`#${sanitizeTitle(index)}`"
                                                            aria-expanded="false"
                                                            :aria-controls="sanitizeTitle(index)">
                                                        <span>{{ index }}</span>
                                                    </button>
                                                </h2>
                                            </div>

                                            <!-- Body-->
                                            <div :id="sanitizeTitle(index)"
                                                 class="collapse"
                                                 :aria-labelledby="`${sanitizeTitle(index)}-header`"
                                                 data-bs-parent="#optional-extras">
                                                <div class="card-body">
                                                    <ul>
                                                        <li v-for="option in options">{{
                                                                option.description }}<!-- +£{{
                                                                option.price }}-->
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Standard Specification -->
                        <div v-else>
                            <div class="row">
                                <div class="col-12">

                                    <div class="accordion" id="standard-specification">
                                        <div
                                            v-for="(spec, index) in derivative.standardEquipmentItemsGrouped"
                                            :key="`standard-specification-${sanitizeTitle(index)}`">

                                            <!-- Header-->
                                            <div class="card-header"
                                                 :id="`${sanitizeTitle(index)}-header`">
                                                <h2 class="mb-0">
                                                    <button class="btn" type="button"
                                                            data-bs-toggle="collapse"
                                                            :data-bs-target="`#${sanitizeTitle(index)}`"
                                                            aria-expanded="false"
                                                            :aria-controls="sanitizeTitle(index)">
                                                        <span>{{ index }}</span>
                                                    </button>
                                                </h2>
                                            </div>

                                            <!-- Body-->
                                            <div :id="sanitizeTitle(index)"
                                                 class="collapse"
                                                 :aria-labelledby="`${sanitizeTitle(index)}-header`"
                                                 data-bs-parent="#standard-specification">
                                                <div class="card-body">
                                                    <ul>
                                                        <li v-for="option in spec">{{
                                                                option.standardEquipmentName
                                                            }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        derivative: null,
        quote: null,
    },
    data() {
        return {
            tab: 'optional-extras',
        }
    },
    methods: {
        sanitizeTitle(title) {
            var slug = "";
            // Change to lower case
            var titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s+/g, '-');

            return slug;
        },
        tabs(tab) {
            this.tab = tab;
        },
    }
};
</script>
